<template>
<div class="chapter">
<div class="inner_page">
<div class="galley">
<div class="body Part" id="section_part--num_2--seq_8"> <div class="title-block"><p class="title-num"><a href="#/9781847674920_toc">PART TWO</a></p> <h1><a href="#/9781847674920_toc">1951</a></h1></div> </div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781847674920_part_02.vue?5760abdc